import React from 'react'
import MarketPlaceFeedCurrentUserProfile from './MarketPlaceFeedCurrentUserProfile'
import MarketPlaceFeedNavbar from './MarketPlaceFeedNavbar'
import MarketPlaceFeedHome from './MarketPlaceFeedHome'
import MarketPlaceFeedOpportunities from './MarketPlaceFeedOpportunities'

const MarketPlaceFeedLayout = () => {
  return (
   <>
    <MarketPlaceFeedNavbar/>
     <div className="container mx-auto md:px-4 mt-6 mb-4">
    
          <div className="flex relative">
            <div className="hidden md:block w-1/4 px-2">
              <div className="sticky top-[80px] max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
                <MarketPlaceFeedCurrentUserProfile />
              </div>
            </div>
            {/* Center Section */}
            <div className="w-full md:w-2/4 md:px-2">
             <div className="sticky top-[80px] max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
               <MarketPlaceFeedHome/>
              </div>
            </div>
            <div className="hidden md:block w-1/4 px-2">
              <div className="sticky top-[80px]  max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
                <MarketPlaceFeedOpportunities/>
              </div>
            </div>
          </div>
        </div>
   </>
  )
}

export default MarketPlaceFeedLayout
